// 在http.js中引入axios
import Vue from 'vue'
import axios from 'axios' // 引入axios
import qs from 'qs' // 引入qs模块，用来序列化post类型的数据，后面会提到
import { message } from 'ant-design-vue'
axios.defaults.withCredentials = true // 让ajax携带cookie
axios.defaults.timeout = 18000 // 请求超时时间
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded;charset=UTF-8'
// 线上
export const baseURL = 'http://106.15.55.204:8080/woco'
Vue.prototype.baseURL = 'http://106.15.55.204:8080/woco' // 上传图片时-得地址前缀
// 本地
// export const baseURL = 'http://192.168.0.108:8080'
// Vue.prototype.baseURL = 'http://192.168.0.108:8080' // 上传图片时-得地址前缀
// http request 拦截器
// 请求拦截(请求发出前处理请求)
axios.interceptors.request.use(
  config => {
    // console.log(localStorage.getItem('Token'))
    if (localStorage.getItem('Token')) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.accessToken = localStorage.getItem('Token')
    }
    return config
  },
  err => {
    console.log(err)
    return Promise.reject(err)
  }
)
// 响应拦截(请求后)
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    console.log(error)
    return Promise.reject(error)
    // if (error.response.status) {
    //   return Promise.reject(error.response)
    // }
  }
)
// 封装数据返回失败提示函数---------------------------------------------------------------------------
function errorState(response) {
  // 隐藏loading
  // 如果http状态码正常，则直接返回数据
  if (
    response &&
    (response.status === 200 ||
      response.status === 304 ||
      response.status === 400)
  ) {
    // 如果不需要除了data之外的数据，可以直接 return response.data
    return response.data
  } else {
    console.log(response.Error)

    message.error('数据获取错误')
  }
}
// 封装数据返回成功提示函数---------------------------------------------------------------------------
function successState(res) {
  // 隐藏loading
  // 统一判断后端返回的错误码(错误码与后台协商而定)
  switch (res.status) {
    /**
     * 10001: 参数不合法
     * 传参时参数有误
     * **/
    case '10001':
      message.error(res.msg)
      break
    /**
     * 10002: 返回数据为空时
     * **/
    case '10002':
      message.error(res.msg)
      break
    /**
     * 10003: 未找到相关内容
     * **/
    // case '10003':
    //   message.error(res.msg)
    //   break
    /**
     * 用于用户登录时的状态
     * 20001: 用户不存在
     * **/
    case '20001':
      message.error(res.msg)
      break
    /**
     * 20002: 用户手机号或密码不正确！
     * **/
    case '20002':
      message.error(res.msg)
      break
    /**
     * 20000: 需要登录
     * **/
    case '20000':
      message.error(res.msg)
      break
    default:
      break
  }
}
// 封装axios--------------------------------------------------------------------------------------
function apiAxios(method, url, params) {
  const httpDefault = {
    method: method,
    baseURL: baseURL,
    url: url,
    // `params` 是即将与请求一起发送的 URL 参数
    // `data` 是作为请求主体被发送的数据
    params: method === 'GET' || method === 'DELETE' ? params : null,
    data: method === 'POST' || method === 'PUT' ? qs.stringify(params) : null,
    timeout: 10000
  }
  // 注意**Promise**使用(Promise首字母大写)
  return new Promise((resolve, reject) => {
    axios(httpDefault)
      // 此处的.then属于axios
      .then(res => {
        successState(res.data)
        resolve(res.data)
      })
      .catch(response => {
        errorState(response)
        reject(response)
      })
  })
}
// 输出函数getAxios、postAxios、putAxios、delectAxios，供其他文件调用-----------------------------
// Vue.js的插件应当有一个公开方法 install。这个方法的第一个参数是 Vue 构造器，第二个参数是一个可选的选项对象。
export default {
  install: function(Vue) {
    Vue.prototype.$getAxios = (url, params) => apiAxios('GET', url, params)
    Vue.prototype.$postAxios = (url, params) => apiAxios('POST', url, params)
    Vue.prototype.$putAxios = (url, params) => apiAxios('PUT', url, params)
    Vue.prototype.$delectAxios = (url, params) =>
      apiAxios('DELECT', url, params)
  }
}
